import * as types from '../constants';
import { STATUS } from '../constants';
import { resolve } from '../api';

export const initialDashboardsState = {
  status: STATUS.IDLE,
  detailsStatus: STATUS.IDLE,
  error: null,
  dashboardIds: [],
  dashboardsById: {},
  widgets: [],
};

export default (state = initialDashboardsState, action) => {
  switch (action?.type) {
    case types.LOAD_DASHBOARDS:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_DASHBOARDS): {
      const dashboardIds = [];
      const dashboardsById = {};
      action.payload.forEach((dashboard) => {
        dashboardIds.push(dashboard?.uuid);
        dashboardsById[dashboard?.uuid] =
          dashboardsById[dashboard?.uuid] || dashboard;
      });
      return {
        ...state,
        dashboardIds,
        dashboardsById,
        status: STATUS.LOADED,
      };
    }
    case types.LOAD_DASHBOARD_DETAILS:
      return {
        ...state,
        detailsStatus: STATUS.LOADING,
      };
    case resolve(types.LOAD_DASHBOARD_DETAILS): {
      const dashboardsById = { ...state?.dashboardsById };
      dashboardsById[action?.payload?.uuid] = action?.payload;
      return {
        ...state,
        dashboardsById,
        detailsStatus: STATUS.LOADED,
      };
    }
    case resolve(types.CREATE_DASHBOARD): {
      const dashboard = action?.payload;
      const dashboardIds = [...state?.dashboardIds];
      const dashboardsById = { ...state?.dashboardsById };
      return {
        ...state,
        dashboardIds: dashboardIds?.concat(dashboard?.uuid),
        dashboardsById: { ...dashboardsById, [dashboard?.uuid]: dashboard },
        status: STATUS.LOADED,
      };
    }
    case resolve(types.DELETE_DASHBOARD):
      return {
        ...state,
        dashboardIds: state?.dashboardIds?.filter(
          (uuid) => uuid !== action?.uuid,
        ),
        status: STATUS.LOADED,
      };
    case resolve(types.UPDATE_DASHBOARD): {
      const dashboard = action?.payload;
      return {
        ...state,
        dashboardsById: {
          ...state?.dashboardsById,
          [dashboard?.uuid]: dashboard,
        },
      };
    }
    case resolve(types.LOAD_WIDGETS): {
      return {
        ...state,
        widgets: action?.payload,
      };
    }
    case resolve(types.UPDATE_DASHBOARD_CELL): {
      const dashboardId = [action?.data?.dashboard];
      const dashboard = state?.dashboardsById[dashboardId];

      const newDashboardsById = {
        ...state?.dashboardsById,
        [dashboardId]: {
          ...dashboard,
          rows: dashboard?.rows?.map((row) => {
            return {
              ...row,
              cells: row?.cells?.map((cell) => {
                if (cell?.uuid === action?.data?.uuid) {
                  return {
                    ...cell,
                    widget: action?.widget,
                  };
                }
                return cell;
              }),
            };
          }),
        },
      };
      return {
        ...state,
        dashboardsById: newDashboardsById,
      };
    }
    default:
      return state;
  }
};
